const FilmChartIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M1.05334 1V13C1.05334 13.5304 1.26406 14.0391 1.63913 14.4142C2.0142 14.7893 2.52291 15 3.05334 15H14.5533M4.05334 9V12M8.05334 6V12M12.0533 3V12"
        stroke="#F97316"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export default FilmChartIcon;
